import React from 'react';

import PropTypes from 'prop-types';

import {
    CarrierLogo,
    TooltipController,
    TooltipSelect,
} from 'wanderu-components';
import {
    localize,
} from 'wanderu-i18n';

// eslint-disable-next-line css-modules/no-unused-class
import styles from './CarrierInfo.scss';

function SingleCarrierInfo(props) {
    const {
        carrierCode,
        carrierName = '',
        t,
        tripModes,
    } = props;
    const tooltipText = `${carrierName} (${tripModes.map((m) => t(`baseApp:${m}`)).join(' + ')})`;

    return (
        <>
            <div className={styles.carrierName}>
                {carrierName}
            </div>
            <TooltipController offsetX="center">
                <TooltipSelect>
                    <CarrierLogo
                        carrierCode={carrierCode}
                        carrierName={carrierName || carrierCode}
                        className={styles.carrierLogo}
                        lazyload={false}
                        tooltip={carrierName}
                    />
                </TooltipSelect>
                {carrierName && (
                    <div>{tooltipText}</div>
                )}
            </TooltipController>
        </>
    );
}

SingleCarrierInfo.propTypes = {
    carrierCode: PropTypes.string.isRequired,
    carrierName: PropTypes.string,
    t: PropTypes.func.isRequired,
    tripModes: PropTypes.arrayOf(PropTypes.string).isRequired,
};

function CarrierInfo(props) {
    const {
        className = '',
        isRouted = false,
        t,
    } = props;

    return (
        <div className={className}>
            {isRouted
                ? t('baseApp:multiple-carriers_tripDetails')
                : <SingleCarrierInfo {...props} />}
        </div>
    );
}

CarrierInfo.propTypes = {
    carrierCode: PropTypes.string.isRequired,
    carrierName: PropTypes.string,
    className: PropTypes.string,
    isRouted: PropTypes.bool,
    t: PropTypes.func.isRequired,
    tripModes: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export { CarrierInfo };
export default localize(CarrierInfo);
